<script setup>
/**
 * FormControlMBasketOrdersInternalEmailMessageId
 * Pass-through interface to render the system's internal operational email log
 * (e.g., admin receipts, fulfillment alerts) within the basket order orchestration view.
 */
import OrdersEmails from '@/common/form-control/OrdersEmails.vue';

defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        /**
         * Accepting String, Number, or Array prevents runtime validation warnings
         * if this control receives historical log lists from the orchestrator.
         */
        type: [String, Number, Array],
        default: null
    }
});
</script>

<template>
    <OrdersEmails v-bind="$props"/>
</template>